import WalletNew from './wallet';

export default WalletNew;
